import { render, staticRenderFns } from "./ScreensList.vue?vue&type=template&id=5a666e18&"
import script from "./ScreensList.vue?vue&type=script&lang=js&"
export * from "./ScreensList.vue?vue&type=script&lang=js&"
import style0 from "./ScreensList.vue?vue&type=style&index=0&id=5a666e18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports